export const ListaSucursales = [
    { value: '001', span: '001' },
    { value: '002', span: '002' },
    { value: '003', span: '003' },
    { value: '004', span: '004' },
    { value: '005', span: '005' },
    { value: '006', span: '006' },
    { value: '007', span: '007' },
    { value: '008', span: '008' },
    { value: '009', span: '009' }
];

export const TiposDocumentoExoneracion = [
    { value: '01', span: 'Compras autorizadas por la Dirección General de Tributación' },
    { value: '02', span: 'Ventas exentas a diplomáticos ' },
    { value: '03', span: 'Autorizado por Ley especial' },
    { value: '04', span: 'Exenciones DGH Autorización Local Genérica' },
    { value: '05', span: 'Exenciones DGH Transitorio V (servicios de ingeniería, arquitectura, topografía obra civil)' },
    { value: '06', span: 'Servicios turísticos inscritos ICT' },
    { value: '07', span: 'Transitorio XVII (Recolección, Clasificación, almacenamiento de Reciclaje y reutilizable)' },
    { value: '08', span: 'Exoneración a Zona Franca' },
    { value: '09', span: 'Exoneración de servicios complementarios para la exportación articulo 11 RLIVA' },
    { value: '10', span: 'Órgano de las corporaciones municipales' },
    { value: '11', span: 'Exenciones DGH Autorización de Impuesto Local Concreta' }
];

export const TiposDocumentoReferencia = [
    { value: '01', span: 'Factura electrónica' },
    { value: '02', span: 'Nota de débito electrónica' },
    { value: '03', span: 'Nota de crédito electrónica' },
    { value: '04', span: 'Tiquete electrónico' },
    { value: '05', span: 'Nota de despacho' },
    { value: '06', span: 'Contrato' },
    { value: '07', span: 'Procedimiento' },
    { value: '08', span: 'Comprobante emitido en contingencia' },
    { value: '09', span: 'Devolución mercadería' },
    { value: '10', span: 'Comprobante electrónico rechazado por el Ministerio de Hacienda' },
    { value: '11', span: 'Sustituye factura rechazada por el Receptor del comprobante' },
    { value: '12', span: 'Sustituye Factura de exportación' },
    { value: '13', span: 'Facturación mes vencido' },
    { value: '14', span: 'Comprobante aportado por contribuyente de Régimen Especial.' },
    { value: '15', span: 'Sustituye una Factura electrónica de Compra' },
    { value: '16', span: 'Comprobante de Proveedor No Domiciliado' },
    { value: '17', span: 'Nota de Crédito a Factura Electrónica de Compra' },
    { value: '18', span: 'Nota de Débito a Factura Electrónica de Compra' },
    { value: '99', span: 'Otros' }
];

export const DocumentosReporte = [
    { value: 'TOD', span: 'Todos' },
    { value: 'FAC', span: 'Factura electrónica' },
    { value: 'ND', span: 'Nota de débito electrónica' },
    { value: 'NC', span: 'Nota de crédito electrónica' },
    { value: 'TIQ', span: 'Tiquete electrónico' },
    { value: 'COM', span: 'Compras' },
    { value: 'FEC', span: 'Factura EleFact. Elect Compra' },
    { value: 'EXP', span: 'Facturas Exportación' },
    { value: 'REP', span: 'Recibo Elect. Pago' },
    { value: 'D104', span: 'D-104' }
];

export const CodigosReferencia = [
    { value: '01', span: 'Anula Documento de Referencia' },
    { value: '02', span: 'Corrige monto' },
    { value: '04', span: 'Referencia a otro documento' },
    { value: '05', span: 'Sustituye comprobante provisional por contingencia' },
    { value: '06', span: 'Devolución de mercancía' },
    { value: '07', span: 'Sustituye comprobante electrónico' },
    { value: '08', span: 'Factura Endosada' },
    { value: '09', span: 'Nota de crédito financiera' },
    { value: '10', span: 'Nota de débito financiera' },
    { value: '11', span: 'Proveedor No Domiciliado' },
    { value: '12', span: 'Crédito por exoneración posterior a la facturación' },
    { value: '99', span: 'Otros' }
];

export const TiposExportacion = [
    { value: 'PDF', span: 'PDF' },
    { value: 'XLS', span: 'Excel Sin Formato' },
    { value: 'XLSS', span: 'Excel Con Formato' },
    { value: 'DOC', span: 'Word' }
];

export const TiposID = [
    { value: '1', span: 'Física' },
    { value: '2', span: 'Jurídica' },
    { value: '3', span: 'Dimex' },
    { value: '4', span: 'NITE' },
    { value: '5', span: 'Extranjero No Domiciliado' },
    { value: '6', span: 'No Contribuyente' }
];

export const TiposIDDosDigitos = [
    { value: '01', span: 'Física' },
    { value: '02', span: 'Jurídica' },
    { value: '03', span: 'Dimex' },
    { value: '04', span: 'NITE' },
    { value: '05', span: 'Extranjero No Domiciliado' },
    { value: '06', span: 'No Contribuyente' }
];

export const ListaTerminales = [
    { value: '1', span: '1' },
    { value: '2', span: '2' },
    { value: '3', span: '3' },
    { value: '4', span: '4' },
    { value: '5', span: '5' }
];

export const Provincias = [
    { value: '1', span: 'San José' },
    { value: '2', span: 'Alajuela' },
    { value: '3', span: 'Cartago' },
    { value: '4', span: 'Heredia' },
    { value: '5', span: 'Guanacaste' },
    { value: '6', span: 'Puntarenas' },
    { value: '7', span: 'Limón' }
];

export const TiposDocsCrearDoc = [
    { value: '1', span: 'Factura', Con:'FAC' },
    { value: '2', span: 'Nota Débito', Con:'ND' },
    { value: '3', span: 'Nota Crédito', Con:'NC' },
    { value: '4', span: 'Tiquete', Con:'TIQ' },
    { value: '8', span: 'Fact Elect Compra', Con:'FEC' },
    { value: '9', span: 'Fact Exportación', Con:'EXP' },
    { value: '10', span: 'Recibo Elect Pago', Con:'REC' },
    { value: 'C', span: 'Cotización', Con:'COT' },
];


export const CodigosImpuestos = [
    { value: '01', span: 'Impuesto al Valor Agregado' },
    { value: '02', span: 'Impuesto Selectivo de Consumo' },
    { value: '03', span: 'Impuesto Único a los combustibles' },
    { value: '04', span: 'Impuesto específico de Bebidas Alcohólicas' },
    { value: '05', span: 'Impuesto Específico sobre las bebidas envasadas sin contenido alcohólico y jabones de tocador' },
    { value: '06', span: 'Impuesto a los Productos de Tabaco' },
    { value: '07', span: 'IVA (cálculo especial)' },
    { value: '08', span: 'IVA Régimen de Bienes Usados (Factor)' },
    { value: '09', span: 'Impuesto Específico al Cemento' }
]

export const InstitucionesExoneran= [
    { value: '01', span: 'Ministerio de Hacienda' },
    { value: '02', span: 'Ministerio de Relaciones Exteriores y Culto' },
    { value: '03', span: 'Ministerio de Agricultura y Ganadería' },
    { value: '04', span: 'Ministerio de Economía, Industria y Comercio' },
    { value: '05', span: 'Cruz Roja Costarricense' },
    { value: '06', span: 'Benemérito Cuerpo de Bomberos de Costa Rica' },
    { value: '07', span: 'Asociación Obras del Espíritu Santo' },
    { value: '08', span: 'Fecrunapa' },
    { value: '09', span: 'EARTH' },
    { value: '10', span: 'INCAE' },
    { value: '11', span: 'Junta de Protección Social (JPS) ' },
    { value: '12', span: 'Aresep' },
    { value: '99', span: 'Otros' }
];

export const CodigosTarifas = [
    { value: '01', span: '0% (CCSS y Municipalidades)' },
    { value: '02', span: 'Tarifa reducida 1%' },
    { value: '03', span: 'Tarifa reducida 2%' },
    { value: '04', span: 'Tarifa reducida 4%' },
    { value: '05', span: 'Transitorio 0%' },
    { value: '06', span: 'Transitorio 4%' },
    { value: '07', span: 'Tarifa transitoria 8% ' },
    { value: '08', span: 'Tarifa general 13%' },
    { value: '09', span: 'Tarifa reducida 0.5%' },
    { value: '10', span: 'Tarifa Exenta' },
    { value: '11', span: 'Tarifa 0% sin derecho a crédito' }
];

export const CodigosTarifasDiferenciadas = [
    { value: '01', span: '0% (CCSS y Municipalidades)', Tarifa: 0 },
    { value: '02', span: 'Tarifa reducida 1%', Tarifa: 1 },
    { value: '03', span: 'Tarifa reducida 2%', Tarifa: 2 },
    { value: '04', span: 'Tarifa reducida 4%', Tarifa: 4 },
    { value: '05', span: 'Transitorio 0%', Tarifa: 0 },
    { value: '06', span: 'Transitorio 4%', Tarifa: 4 },
    { value: '07', span: 'Tarifa transitoria 8%', Tarifa: 8 },
    { value: '08', span: 'No Aplica', Tarifa: 13 },
    { value: '09', span: 'Tarifa reducida 0.5%', Tarifa: 0.5 },
    { value: '10', span: 'Tarifa Exenta', Tarifa: 0 },
    { value: '11', span: 'Tarifa 0% sin derecho a crédito', Tarifa: 0 }
];
export const CondicionesPago = [
    { value: '01', span: 'Contado' },
    { value: '02', span: 'Crédito' },
    { value: '03', span: 'Consignación' },
    { value: '04', span: 'Apartado' },
    { value: '05', span: 'Arrendamiento con opción de compra' },
    { value: '06', span: 'Arrendamiento en función financiera' },
    { value: '07', span: 'Cobro a favor de un tercero' },
    { value: '08', span: 'Servicios prestados al Estado' },
    { value: '09', span: 'Pago de servicios prestado al Estado' },
    { value: '10', span: 'Venta a crédito en IVA hasta 90 días (Artículo 27, LIVA)' },
    { value: '11', span: 'Pago de venta a crédito en IVA hasta 90 días (Artículo 27, LIVA)' },
    { value: '12', span: 'Venta Mercancía No Nacionalizada' },
    { value: '13', span: 'Venta Bienes Usados No Contribuyente' },
    { value: '14', span: 'Arrendamiento Operativo' },
    { value: '15', span: 'Arrendamiento Financiero' }
];

export const ListaPlanes = [
    { value: 'D', span: 'Prepago' },
    { value: 'P', span: 'Mensual' },
    { value: 'S', span: 'Suspendido' }
];

export const LasMonedas = [
    { value: 'CRC', span: 'Colones' },
    { value: 'USD', span: 'Dolares' }
];

export const EstadosArticulos = [
    { value: 'ACT', span: 'Activo' },
    { value: 'FUE', span: 'Fuera Venta' }
];

export const EstadoUsuarios = [
    { value: '1', span: 'Activo' },
    { value: '2', span: 'Suspendido' }
];

export const Ambientes = [
    { value: 'T', span: 'Productivo' },
    { value: 'F', span: 'Pruebas' }
];

export const tiposTributario = [
    { value: '1', span: 'Normal' },
    { value: '0', span: 'Exonerado' }
];

export const EstadosDocumentos = [
    { value: 'ACE', span: 'Aceptado' },
    { value: 'PEN', span: 'Pendiente' },
    { value: 'REC', span: 'Rechazado' }
];
export const PorcentajesExoneracion = [
    { value: '1', span: '1% (Cliente paga un 12%)' },
    { value: '2', span: '2% (Cliente paga un 11%)' },
    { value: '3', span: '3% (Cliente paga un 10%)' },
    { value: '4', span: '4%' },
    { value: '5', span: '5%' },
    { value: '6', span: '6%' },
     { value: '7', span: '7%' },
    { value: '8', span: '8%' },
    { value: '9', span: '9%' },
    { value: '10', span: '10% (Cliente paga un 3%)' },
    { value: '11', span: '11% (Cliente paga un 2%)' },
    { value: '12', span: '12% (Cliente paga un 1%)' },
    { value: '13', span: '13% (Cliente no paga IVA)' }
];   

export const SiNo= [
    { value: 'S', span: 'Si' },
    { value: 'N', span: 'No' }
];
export const SiNoNum= [
    { value: '1', span: 'Si' },
    { value: '0', span: 'No' }
];

export const OpcionesExportacion = [
    { value: 'P', text: 'PDF' },
    { value: 'E', text: 'Excel' },
    { value: 'W', text: 'Word' }
];



export const EncApi = (Token) => ({
    headers: {
        Authorization: "Bearer " + Token,
        "x-rapidapi-key": "apikey",
        "content-type": "application/json",
        "accept": "application/json",
        "access-control-allow-origin": "*"
    }
});
export const EncabezadoPost = (Token, Cuerpo) => ({
    method: 'POST',
    body: JSON.stringify(Cuerpo),
    headers: {
        Authorization: "Bearer " + Token,
        "x-rapidapi-key": "apikey",
        "content-type": "application/json",
        "accept": "application/json",
        "access-control-allow-origin": "*"
    }
});

export const FormasFarmaceuticas = [
    { value: '00', span: 'No Aplica' },
    { value: '01', span: 'Anillo vaginal' },
    { value: '02', span: 'Aposito' },
    { value: '03', span: 'Capleta' },
    { value: '04', span: 'Cápsula' },
    { value: '05', span: 'Cápsula blanda' },
    { value: '06', span: 'Capsula con granulado con recubrimiento enterico' },
    { value: '07', span: 'Cápsula con gránulos de liberación retardada' },
    { value: '08', span: 'Cápsula con pellets entéricos' },
    { value: '09', span: 'Capsula de gelatina blanda' },
    { value: '10', span: 'Cápsula de gelatina dura' },
    { value: '11', span: 'Capsula de gelatina suave' },
    { value: '12', span: 'Cápsula de liberación controlada' },
    { value: '13', span: 'Capsula de liberacion prolongada' },
    { value: '14', span: 'Capsula de liberacion retardada ' },
    { value: '15', span: 'Cápsula de liberación retardada (conteniendo gránulos con cubierta entéric)' },
    { value: '16', span: 'Capsula de liberacion retardada gastrorresistente' },
    { value: '17', span: 'Cápsula de liberación retardada(conteniendo gránulos con cubierta entérica)' },
    { value: '18', span: 'Capsula dura' },
    { value: '19', span: 'Capsula dura de liberacion prolongada' },
    { value: '20', span: 'Capsula gastrorresistente' },
    { value: '21', span: 'Cápsula para inhalación' },
    { value: '22', span: 'Capsulas con granulos entericos' },
    { value: '23', span: 'Cápsulas con microgránulos de liberación prolongada' },
    { value: '24', span: 'Capsulas con microgranulos gastrorresistentes' },
    { value: '25', span: 'Cápsulas con pellets de liberación prolongada' },
    { value: '26', span: 'Cápsulas de liberación modificada' },
    { value: '27', span: 'Capsulas duras de liberación prolongada' },
    { value: '28', span: 'Cápsulas duras gastrorresistentes' },
    { value: '29', span: 'Cápsulas para inhalación' },
    { value: '30', span: 'Caramelo' },
    { value: '31', span: 'Champu' },
    { value: '32', span: 'Comprimido' },
    { value: '33', span: 'Comprimido bicapa' },
    { value: '34', span: 'Comprimido bucodispersable' },
    { value: '35', span: 'Comprimido con cubierta pelicular' },
    { value: '36', span: 'Comprimido con recubrimiento enterico' },
    { value: '37', span: 'Comprimido de disolucion bucal' },
    { value: '38', span: 'Comprimido de liberación modificada ' },
    { value: '39', span: 'Comprimido de liberación osmótica' },
    { value: '40', span: 'Comprimido de liberacion prolongada' },
    { value: '41', span: 'Comprimido de liberacion retardada' },
    { value: '42', span: 'Comprimido dispersable' },
    { value: '43', span: 'Comprimido dispersable / masticable' },
    { value: '44', span: 'Comprimido efervescente' },
    { value: '45', span: 'Comprimido entérico' },
    { value: '46', span: 'Comprimido gastrorresistente' },
    { value: '47', span: 'Comprimido masticable' },
    { value: '48', span: 'Comprimido orodispersable' },
    { value: '49', span: 'Comprimido peliculado de liberacion modificada' },
    { value: '50', span: 'Comprimido peliculado de liberación prolongada' },
    { value: '51', span: 'Comprimido ranurado' },
    { value: '52', span: 'Comprimido recubierto' },
    { value: '53', span: 'Comprimido recubierto con película' },
    { value: '54', span: 'Comprimido recubierto de liberación prolongada' },
    { value: '55', span: 'Comprimido recubierto gastroresistente' },
    { value: '56', span: 'Comprimido sublingual' },
    { value: '57', span: 'Comprimidos de liberación prolongada recubiertos con película' },
    { value: '58', span: 'Comprimidos ranurados de liberación modificada' },
    { value: '59', span: 'Comprimidos recubiertos de liberación controlada' },
    { value: '60', span: 'Comprimidos recubiertos de liberación sostenida' },
    { value: '61', span: 'Comprimidos revestidos' },
    { value: '62', span: 'Concentrado para solución inyectable' },
    { value: '63', span: 'Concentrado para solución para infusión' },
    { value: '64', span: 'Concentrado para solución para perfusión' },
    { value: '65', span: 'Crema' },
    { value: '66', span: 'Crema vaginal' },
    { value: '67', span: 'Dispersión liposomal inyectable endovenosa' },
    { value: '68', span: 'Dispositivo vaginal con polvo' },
    { value: '69', span: 'Elixir' },
    { value: '70', span: 'Emulsion' },
    { value: '71', span: 'Emulsion inyectable' },
    { value: '72', span: 'Emulsion oral' },
    { value: '73', span: 'Enema' },
    { value: '74', span: 'Enjuague bucal' },
    { value: '75', span: 'Espuma' },
    { value: '76', span: 'Gas medicinal' },
    { value: '77', span: 'Gas para inhalación' },
    { value: '78', span: 'Gasa impregnada con ungüento' },
    { value: '79', span: 'Gel' },
    { value: '80', span: 'Gel capilar' },
    { value: '81', span: 'Gel oftalmico' },
    { value: '82', span: 'Gel oral' },
    { value: '83', span: 'Gel vaginal' },
    { value: '84', span: 'Gotas óticas en solución' },
    { value: '85', span: 'Gragea' },
    { value: '86', span: 'Gragea de liberación prolongada' },
    { value: '87', span: 'Gragea gastroresistente' },
    { value: '88', span: 'Granulado para solución oral' },
    { value: '89', span: 'Granulado para suspension' },
    { value: '90', span: 'Gránulo gastrorresistente para suspensión' },
    { value: '91', span: 'Granulos' },
    { value: '92', span: 'Gránulos de liberación prolongada' },
    { value: '93', span: 'Gránulos de liberación prolongada para suspensión' },
    { value: '94', span: 'Gránulos efervescentes' },
    { value: '95', span: 'Gránulos gastro-resistentes' },
    { value: '96', span: 'Gránulos para solución' },
    { value: '97', span: 'Gránulos para suspensión' },
    { value: '98', span: 'Implante' },
    { value: '99', span: 'Jabón sólido' },
    { value: '100', span: 'Jalea' },
    { value: '101', span: 'Jarabe' },
    { value: '102', span: 'Jarabe (solución oral)' },
    { value: '103', span: 'Laca para uñas' },
    { value: '104', span: 'Liofilizado para suspensión inyectable' },
    { value: '105', span: 'Líquido' },
    { value: '106', span: 'Líquido anestésico' },
    { value: '107', span: 'Líquido para inhalación' },
    { value: '108', span: 'Líquido para inhalación del vapor' },
    { value: '109', span: 'Líquido viscoso' },
    { value: '110', span: 'Loción' },
    { value: '111', span: 'Microesferas liofilizadas estériles' },
    { value: '112', span: 'Microesferas para suspensión inyectable' },
    { value: '113', span: 'Mixtura' },
    { value: '114', span: 'Óvulo' },
    { value: '115', span: 'Parche' },
    { value: '116', span: 'Parche transdérmico' },
    { value: '117', span: 'Pastilla' },
    { value: '118', span: 'Película bucodispersable' },
    { value: '119', span: 'Polvo' },
    { value: '120', span: 'Polvo concentrado para solución para infusión' },
    { value: '121', span: 'Polvo para suspensión de liberación prolongada para jeringa prellenada' },
    { value: '122', span: 'Polvo cristalino para solución inyectable' },
    { value: '123', span: 'Polvo efervescente' },
    { value: '124', span: 'Polvo estéril para solución inyectable' },
    { value: '125', span: 'Polvo granulado' },
    { value: '126', span: 'Polvo granulado para solución oral' },
    { value: '127', span: 'Polvo liofilizado' },
    { value: '128', span: 'Polvo liofilizado para concentrado para solución para perfusión' },
    { value: '129', span: 'Polvo liofilizado para solución inyectable' },
    { value: '130', span: 'Polvo liofilizado para solución para infusión intravenosa' },
    { value: '131', span: 'Polvo liofilizado para solución para perfusión' },
    { value: '132', span: 'Polvo liofilizado para suspensión inyectable' },
    { value: '133', span: 'Polvo liofilizado para suspensión inyectable de liberación prolongada' },
    { value: '134', span: 'Polvo liofilizado para uso parenteral' },
    { value: '135', span: 'Polvo para concentrado para solución para infusión' },
    { value: '136', span: 'Polvo para concentrado para solución para infusión intravenosa' },
    { value: '137', span: 'Polvo para concentrado para solución para perfusión' },
    { value: '138', span: 'Polvo para concentrado para solución para perfusión intravenoso' },
    { value: '139', span: 'Polvo para infusión' },
    { value: '140', span: 'Polvo para inhalación' },
    { value: '141', span: 'Polvo para inhalación en cápsulas' },
    { value: '142', span: 'Polvo para inhalación en cápsulas duras' },
    { value: '143', span: 'Polvo para solución' },
    { value: '144', span: 'Polvo para solución estéril inyectable' },
    { value: '145', span: 'Polvo para solución inyectable' },
    { value: '146', span: 'Polvo para solución oral' },
    { value: '147', span: 'Polvo para solución para infusión' },
    { value: '148', span: 'Polvo para solución para perfusión' },
    { value: '149', span: 'Polvo para suspensión' },
    { value: '150', span: 'Polvo para suspensión inyectable' },
    { value: '151', span: 'Polvo para suspensión oral' },
    { value: '152', span: 'Polvo para suspensión oral y rectal' },
    { value: '153', span: 'Polvo tópico' },
    { value: '154', span: 'Polvo y disolvente para solución inyectable.' },
    { value: '155', span: 'Pomada' },
    { value: '156', span: 'Sistema de liberación vaginal' },
    { value: '157', span: 'Sistema intrauterino de liberación' },
    { value: '158', span: 'Solución' },
    { value: '159', span: 'Solución anestésica inhalatoria' },
    { value: '160', span: 'Solución concentrada' },
    { value: '161', span: 'Solución concentrada para infusión' },
    { value: '162', span: 'Solución de infusión para aplicación intravenosa' },
    { value: '163', span: 'Solución en aerosol' },
    { value: '164', span: 'Solución en spray' },
    { value: '165', span: 'Solución estéril' },
    { value: '166', span: 'Solución estéril para inyección' },
    { value: '167', span: 'Solución gotas' },
    { value: '168', span: 'Solución intraocular' },
    { value: '169', span: 'Solución inyectable' },
    { value: '170', span: 'Solución inyectable concentrada' },
    { value: '171', span: 'Solución inyectable concentrado para infusión' },
    { value: '172', span: 'Solución inyectable de liberación prolongada' },
    { value: '173', span: 'Solución inyectable para infusión' },
    { value: '174', span: 'Solución oftálmica' },
    { value: '175', span: 'Solución oleosa inyectable' },
    { value: '176', span: 'Solución oral' },
    { value: '177', span: 'Solución para diálisis peritoneal' },
    { value: '178', span: 'Solución para hemodiálisis' },
    { value: '179', span: 'Solución para infusión intravenosa' },
    { value: '180', span: 'Solución para inhalación' },
    { value: '181', span: 'Solución para irrigación' },
    { value: '182', span: 'Solución para nebulización' },
    { value: '183', span: 'Solución para perfusión' },
    { value: '184', span: 'Solución para uñas' },
    { value: '185', span: 'Solución rectal' },
    { value: '186', span: 'Spray solución nasal' },
    { value: '187', span: 'Supositorio' },
    { value: '188', span: 'Suspensión' },
    { value: '189', span: 'Suspensión para inhalación' },
    { value: '190', span: 'Suspensión acuosa' },
    { value: '191', span: 'Suspensión en aerosol' },
    { value: '192', span: 'Suspensión en spray' },
    { value: '193', span: 'Suspensión estéril' },
    { value: '194', span: 'Suspensión inyectable' },
    { value: '195', span: 'Suspensión inyectable de liberación prolongada' },
    { value: '196', span: 'Suspensión oral' },
    { value: '197', span: 'Suspensión para inhalación' },
    { value: '198', span: 'Suspensión presurizada' },
    { value: '199', span: 'Tableta' },
    { value: '200', span: 'Tableta bicapa' },
    { value: '201', span: 'Tableta con capa entérica' },
    { value: '202', span: 'Tableta con cubierta entérica' },
    { value: '203', span: 'Tableta cubierta' },
    { value: '204', span: 'Tableta de acción prolongada' },
    { value: '205', span: 'Tableta de liberación prolongada' },
    { value: '206', span: 'Tableta de liberación retardada' },
    { value: '207', span: 'Tableta dispersable' },
    { value: '208', span: 'Tableta efervescente' },
    { value: '209', span: 'Tableta masticable' },
    { value: '210', span: 'Tableta orodispersable' },
    { value: '211', span: 'Tableta para chupar' },
    { value: '212', span: 'Tableta ranurada' },
    { value: '213', span: 'Tableta recubierta' },
    { value: '214', span: 'Tableta recubierta con película' },
    { value: '215', span: 'Tableta recubierta de liberación extendida' },
    { value: '216', span: 'Tableta recubierta de liberación modificada' },
    { value: '217', span: 'Tableta recubierta de liberación prolongada' },
    { value: '218', span: 'Tableta recubierta entérica' },
    { value: '219', span: 'Tableta recubierta gastrorresistente' },
    { value: '220', span: 'Tableta revestida' },
    { value: '221', span: 'Tableta sublingual' },
    { value: '222', span: 'Tabletas de disolución oral instantánea' },
    { value: '223', span: 'Tabletas de liberación extendida' },
    { value: '224', span: 'Tabletas dispersables / masticables' },
    { value: '225', span: 'Tabletas laqueadas' },
    { value: '226', span: 'Tabletas recubiertas de acción prolongada' },
    { value: '227', span: 'Tabletas recubiertas de liberación retardada' },
    { value: '228', span: 'Tintura' },
    { value: '229', span: 'Ungüento' }

]